import fetchUserLists from './fetch-user-lists';

export default () => {
  $(document).on('click', '[data-open-share-wishlist-link-modal]', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const $item = $(e.currentTarget);

    $($item.data('modal')).modal({
      fadeDuration: 250,
      fadeDelay: 0.80,
    });

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      // [ADA]
      $('#share-wishlist-link-modal .close-modal').attr('role', 'button');
      $('#share-wishlist-link-modal .close-modal').trigger('focus');
      $('#share-wishlist-link-modal .close-modal').removeAttr('style');
    });

    const lists = await fetchUserLists();
    const wishlist_item = _.find(lists, { lname: 'My Wishlist' });
    if (typeof wishlist_item === 'undefined') {
      console.log(`Customer's wishlist not found`);
      return;
    }

    const wishlist_id = wishlist_item.lid;

    // Generate the link
    if (window._swat) {
      const onSuccess = (link, lid) => {
        // console.log('Successfully Generated Link ', link, lid);
        let customer_name = (window.theme.customer.first_name !== null) ? window.theme.customer.first_name : '';
        customer_name = (window.theme.customer.last_name !== null) ? `${customer_name} ${window.theme.customer.last_name}` : '';

        $('[data-wishlist-link]').val(`https://www.astrthelabel.com/pages/shared-wishlist?hkey=${lid}&lid=${lid}&ff_name=${encodeURIComponent(customer_name)}`);
      };

      const onError = (error) => {
        // Error is an xhrObject
        console.log('Error while generating the link', error);
      };
      
      window._swat.generateSharedListURL(wishlist_id, onSuccess, onError);
    }
  });

  $(document).on('click', '[data-copy-wishlist-link]', async (e) => {
    const $item = $(e.currentTarget);

    // Copy the value of the input to the clipboard
    await navigator.clipboard.writeText($('[data-wishlist-link]').val());

    $item.find('span').text('Copied!');

    window.setTimeout(() => {
      $item.find('span').text('Copy link');
    }, 500);
  });

  // [ADA]
  const share_button = document.querySelector('[data-open-share-wishlist-link-modal]');
  if (share_button) {
    share_button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        share_button.click();
      }
    });
  }

  const copy_wishlist = document.querySelector('[data-copy-wishlist-link]');
  if (copy_wishlist) {
    copy_wishlist.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        copy_wishlist.click();
      }
    });
  }
};
